import Backbone from 'init/backbone'
import { View } from 'es6/components/view'
import { Defaults } from 'es-decorators'
import { scriptLoader } from 'helpers/script-loader-helper'
import { getTemplate } from 'helpers/template-helper'
import { okoPush } from 'helpers/oko-helpers'
import isFunction from 'lodash/isFunction'
import merge from 'lodash/merge'

@Defaults({
  additionalOptions: ['selector'],
  events: {
    'click .js-popup-close': 'remove',
    'click': 'closeOnExternalClick',
  },
  isYTLoaded: false,
})
export class YoutubePopupView extends View {
  /** @inheritDoc */
  run () {
    $(this.selector).on('click', this.show.bind(this))
    this.template = getTemplate('#youtube-player-template')
    this.$popups = $('.popups')
    this.initYoutubeScript()
  }

  /**
   * Инициализация внешнего скрипта YouTube.
   */
  initYoutubeScript () {
    window.onYouTubeIframeAPIReady = () => {
      this.isYTLoaded = true
    }
    scriptLoader('//www.youtube.com/player_api', 'YT')
      .then(YT => {
        this.YT = YT
      })
  }

  /**
   * Закрытие попапа если клик вне области видео.
   * @param {Event} currentTarget Элемент по которому произведен клик.
   */
  closeOnExternalClick ({ currentTarget }) {
    if (this.$el.is(currentTarget)) {
      this.remove()
    }
  }

  /**
   * Отображение плеера.
   * @param {Event} e Событие клика на открывающий элемент.
   */
  show (e) {
    if (this.isYTLoaded && this.YT) {
      Backbone.trigger('block-screen')
      e.preventDefault()
      e.stopPropagation()
      const $opener = $(e.currentTarget)
      this.$el = $(this.template())
      this.$popups.append(this.$el)
      this.delegateEvents()
      this.player = new this.YT.Player('js-youtube-player', {
        width: '960px',
        height: '560px',
        videoId: $opener.data('youtube-id'),
        playerVars: {
          controls: 1,
          showinfo: 0,
          modestbranding: 0,
          frameborder: 0,
        },
        events: {
          onStateChange: event => {
            const { data } = event
            switch (data) {
              case -1:
                this.videoUrl = isFunction(this.player.getVideoUrl)
                  ? this.player.getVideoUrl()
                  : ''
                break
              case 1:
                this.onPlaying(event)
                break
              case 0:
              case 2:
                this.onPauseOrEnded(data)
            }
          },
        },
      })
      this.sendToOkoClick(e)
    }
  }

  /**
   * Отправляем событие в око при открытии попапа
   * @param {Event} e Событие клика.
   */
  sendToOkoClick (e) {
    const parent = e.target.parentElement.closest('div')
    const chponkUrl = parent.getAttribute('data-chponck-url')
    okoPush(merge({
      n: 'banner-click',
      'id': parseInt(parent.getAttribute('data-chponck-id'), 10),
      'num': parseInt(parent.getAttribute('data-chponck-num'), 10),
      'url': chponkUrl ? String(chponkUrl).trim() : '',
      'place_id': parseInt(parent.getAttribute('data-chponck-place-id'), 10),
    }))
  }

  /**
   * Отправка данных в ОКО при воспроизведении.
   * @param {Event} event Событие воспроизведения.
   */
  onPlaying (event) {
    const { target } = event
    okoPush({
      n: 'video',
      time: Number(target.getCurrentTime().toFixed(0)),
      url: this.videoUrl,
    })
    okoPush({
      n: 'video',
      action: 'play',
      url: this.videoUrl,
    })
    this.okoInterval = setInterval(() => {
      okoPush({
        n: 'video',
        time: Number(target.getCurrentTime().toFixed(0)),
        url: this.videoUrl,
      })
    }, 10000)
  }

  /**
   * Отправка событий в ОКО при паузе или окончании воспроизведения.
   * @param {number} eventType Тип события (0 - окончено, 2 - пауза)
   */
  onPauseOrEnded (eventType) {
    const action = eventType === 0 ? 'ended' : 'pause'
    clearInterval(this.okoInterval)
    okoPush({
      n: 'video',
      action,
      url: this.videoUrl,
    })
  }

  /** @inheritDoc */
  remove () {
    Backbone.trigger('block-screen')
    clearInterval(this.okoInterval)
    if (this.player) {
      this.player.destroy()
    }
    super.remove()
  }
}
